import { FirestoreEntity, Mapper, TimestampDtoToTimestampMapper } from '../../../@harmony';
import { Album, AlbumDto, AlbumEntity, AlbumStatus } from '../..';
import { Timestamp } from 'firebase/firestore';

export class AlbumToAlbumEntityMapper implements Mapper<Album, FirestoreEntity<AlbumEntity>> {
  public map(from: Album): FirestoreEntity<AlbumEntity> {
    return new FirestoreEntity(from.id, {
      _version: 0,
      availableToDomainUsers: from.availableToDomainUsers,
      createdAt: Timestamp.fromDate(from.createdAt),
      createdBy: from.createdBy,
      description: from.description,
      folder: from.folder,
      groups: from.groups,
      internalId: from.internalId,
      isPublic: from.isPublic,
      isUserDefaultAlbum: from.isUserDefaultAlbum,
      location: from.location,
      name: from.name,
      publicPasswordHash: from.publicPasswordHash,
      systemStatus: from.systemStatus,
      teamId: from.teamId,
      users: from.users,
    });
  }
}

export class AlbumDtoToAlbumEntityMapper implements Mapper<AlbumDto, FirestoreEntity<AlbumEntity>> {
  private readonly timestampMapper = new TimestampDtoToTimestampMapper();

  public map(from: AlbumDto): FirestoreEntity<AlbumEntity> {
    return {
      id: from.id,
      data: {
        ...from.data,
        createdAt: this.timestampMapper.map(from.data.createdAt),
      },
    };
  }
}

export class AlbumEntityToAlbumMapper implements Mapper<FirestoreEntity<AlbumEntity>, Album> {
  public map(from: FirestoreEntity<AlbumEntity>): Album {
    return new Album(
      from.id,
      from.data.availableToDomainUsers,
      from.data.createdAt.toDate(),
      from.data.createdBy,
      from.data.description,
      from.data.folder,
      from.data.groups ?? [],
      from.data.internalId,
      from.data.isPublic ?? false,
      from.data.isUserDefaultAlbum ?? false,
      from.data.location,
      from.data.name,
      from.data.publicPasswordHash,
      from.data.systemStatus ?? AlbumStatus.Active,
      from.data.teamId,
      from.data.users,
    );
  }
}
